import { connect } from "react-redux"
import {
    getBusStops,
    getBusRoutes,
    getBusStopsEta,
    getBusRoutesEta,
    getDestinations,
    getLocations,
    getLocationEta,
    getShuttleSchedules,
    getStopsByRouteAndSequence,
    resetMeta,
    resetPage
} from "../actions/TransportPage"

const mapStateToProps = state => ({
    pageProps: state.transportPageReducer
})

const mapDispatchToProps = dispatch => ({
    getBusStops(query) { dispatch(getBusStops(query)) },
    getBusRoutes() { dispatch(getBusRoutes()) },
    getBusStopsEta(query) { dispatch(getBusStopsEta(query)) },
    getBusRoutesEta(query) { dispatch(getBusRoutesEta(query)) },
    getDestinations() { dispatch(getDestinations()) },
    getLocations() { dispatch(getLocations()) },
    getLocationEta(query) { dispatch(getLocationEta(query)) },
    getShuttleSchedules() { dispatch(getShuttleSchedules()) },
    getStopsByRouteAndSequence(query) { dispatch(getStopsByRouteAndSequence(query)) },
    resetPage() { dispatch(resetPage()) },
    resetMeta() { dispatch(resetMeta()) }
})

const connectTransport = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component)

export default connectTransport
